/*  iceberg-ui  */
import { Box } from '@auviknetworks/iceberg-ui';

/*  MUI  */
import { Alert } from '@mui/material';

/*  React  */
import React, { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';

export const ReportHasNoData = () => {
    const { t } = useTranslation();
    const elementRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        elementRef.current?.scrollIntoView({ behavior: 'smooth' });
    }, []);

    return (
        <Box
            ref={elementRef}
            data-testid="reportHasNoData"
            data-trackid="reportHasNoData"
        >
            <Alert
                data-testid="reportHasNoDataAlert"
                severity="warning"
                icon={false}
            >
                {t('Report.no_data_notice')}
            </Alert>
        </Box>
    );
};
